import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button, Checkbox } from 'react-bootstrap';
import rest from 'rest';

import { REST_API_URL } from "../../../Utils/Global";

import Grid from '../../Helper/Grid';
import Status from '../../Helper/Status';
import ModalMessage from '../../Helper/ModalMessage';

/**
* Class PermissionGrid
* Component to generate permission grid
**/
class PermissionGrid extends Grid {

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);
    this.state = {objects: [], fields: [], status: {}, modalMessage: {}, filters: {}};
    // Bind event functions to keep scope
    this.saveChanges = this.saveChanges.bind(this);
    this.fireSynchronization = this.fireSynchronization.bind(this);
  }

  /**
  * componentWillMount
  * Pre-rendering component function : loading fields to display
  **/
  componentWillMount() {
    let fieldsUrl = REST_API_URL + this.props.path + '/fields';
    if(this.props.customFieldsUrl !== undefined) {
      fieldsUrl = REST_API_URL + this.props.path + '/' + this.props.customFieldsUrl;
    }

    rest({method: 'GET', path: fieldsUrl, mixin: {withCredentials: true}}).then(response => {
      let state = this.state;
      state.fields = JSON.parse(response.entity);
      state.fields.forEach(component => {
        state.filters["tablePermission" + component.nom] = true;
      });

			this.setState(state);
		});
  }

  /**
  * componentDidMount
  * Post-rendering component function : loading data
  **/
	componentDidMount() {
		rest({method: 'GET', path: REST_API_URL + this.props.objectPath + '/'}).then(response => {
      const res = JSON.parse(response.entity);
      let state = this.state;
      state.objects = res;
			this.setState(state);
		});
	}

  /**
  * getCheckboxFormatterFunction
  * Returns the checkbox rendering function
  **/
  getCheckboxFormatterFunction() {
    const permissionGrid = this;

    // Returns the function to keep permissionGrid reference !!!
    return function(value, obj, opt, rowIndex) {

      const cellItem = this;
      const props = {
        className: "chkPermission",
        name: obj.groupId + "_" + this.name,
        onChange: function(event) {
          // Modidy table data state
          const checkbox = event.target;
          let tableState = permissionGrid.refs.tablePermission.state;
          tableState.data[rowIndex][cellItem.name] = checkbox.checked.toString();
          permissionGrid.refs.tablePermission.setState(tableState);
        }
      };

      if(value === "true") {
        props.checked = true;
      }

      return <Checkbox {...props} />;
    };
  }

  handleFilterColumn(event) {
    const chk = event.target;
    let state = { ...this.state };
    state.filters[chk.name] = chk.checked;
    this.setState(state);
  }

  getFilters(componentHeaderRefs) {
    const chks = componentHeaderRefs.map(({name, ref}) => {
      const props = {
        key: ref,
        name: ref,
        onChange: this.handleFilterColumn.bind(this),
        checked: this.state.filters[ref],
      };

      return <Checkbox {...props}>{name}</Checkbox>
    });

    let td = [];
    let tmpTd = [];

    chks.forEach((chk, index) => {
      tmpTd.push(chk);

      if(tmpTd.length === 5) {
        td.push(<td key={index}>{tmpTd}</td>);
        tmpTd = [];
      }
    });

    if(tmpTd.length > 0)
      td.push(<td key={chks.length}>{tmpTd}</td>);

    const tous =
      <td>
        <Button onClick={ () => {
          let state = { ...this.state };
          for(const key in state.filters) state.filters[key] = true;
          this.setState(state);
        }}>Tous</Button>
      </td>;

    const aucun =
      <td>
        <Button onClick={ () => {
          let state = { ...this.state };
          for(const key in state.filters) state.filters[key] = false;
          this.setState(state);
        }}>Aucun</Button>
      </td>;

    return <table className="permissionColFilter"><tbody><tr>{td}{tous}{aucun}</tr></tbody></table>;
  }

  /**
  * render
  * Rendering component function : display the grid
  **/
  render() {
    if(this.state.fields.length === 0) {
        return <div></div>;
    }

    // Concatenate grid headers (components)
    const { headers, componentHeaderRefs } = this.getHeaders();

    const filters = this.getFilters(componentHeaderRefs);

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Modal message
    const modalMessage = <ModalMessage parent={this} {...this.state.modalMessage} />;

    const options = {
      noDataText: 'Aucune donnée à afficher',
      expandBy: "row",
    };

    let tableProps = {
      ref: "tablePermission",
      data: this.state.objects,
      options: options,
      striped: true,
      hover: true,
      condensed: true,
    };

    // Creating Grid
    const table =
      <div className="listContainer">
        {modalMessage}
        {status}
        {filters}
        <div className={"grid PermissionGrid"}>
          <BootstrapTable {...tableProps}>
            {headers}
          </BootstrapTable>
        </div>
        <Button bsStyle="success" onClick={this.saveChanges} className="PermissionGridSave">Sauvegarder les changements</Button>
        {this.props.synchronize !== false && <Button bsStyle="warning" onClick={this.fireSynchronization} className="PermissionGridSynchro">Synchroniser les groupes avec la base de données</Button>}
      </div>;

    return (table);
  }

  getHeaders() {
    const thisRef = this;
    let componentHeaderRefs = [], headers = [];

    if(this.props.isComponent) {
      headers = this.state.fields.map(component => {
        const componentProps = {
          key: component.nom,
          ref: "tablePermission" + component.nom,
          row: '0',
          colSpan: component.fieldBoList.length,
          headerAlign: 'center',
          dataSort: false,
          hidden: thisRef.state.filters["tablePermission" + component.nom] === false,
        };

        // Concatenate grid subheaders (rights)
        let subHeaders = component.fieldBoList.map(right => {
          const rightProps = {
            className: "permissionsSubHeader",
            key: right.nom,
            isKey: right.isKey,
            ref: "tablePermission" + component.nom + "_" + right.nom,
            row: '1',
            dataField: component.nom + "_" + right.nom,
            dataFormat: thisRef.getCheckboxFormatterFunction(),
            width: '70',
            dataAlign: 'center',
            headerAlign: 'center',
            dataSort: false,
            hidden: thisRef.state.filters["tablePermission" + component.nom] === false,
          };

          return <TableHeaderColumn {...rightProps}>{right.libelle}</TableHeaderColumn>;
        });

        componentHeaderRefs.push({ name: component.libelle, ref: "tablePermission" + component.nom });
        subHeaders.unshift(<TableHeaderColumn {...componentProps}>{component.libelle}</TableHeaderColumn>);

        return subHeaders;
      });
    } else {
      headers = this.state.fields.map(layer => {
        const layerProps = {
          key: layer.nom,
          className: "permissionsSubHeader",
          ref: "tablePermission" + layer.nom,
          dataField: layer.nom,
          dataFormat: thisRef.getCheckboxFormatterFunction(),
          headerAlign: 'center',
          dataAlign: 'center',
          dataSort: false,
          width: "120",
          hidden: thisRef.state.filters["tablePermission" + layer.nom] === false,
        };

        componentHeaderRefs.push({ name: layer.libelle, ref: "tablePermission" + layer.nom });
        return <TableHeaderColumn {...layerProps}>{layer.libelle}</TableHeaderColumn>;
      });
    }

    // Add groups column
    let headerGroupProps = {
      key: "groupId",
      dataField: "groupName",
      isKey: true,
      ref: "tablePermissionGroups",
      width: '120',
      dataSort: false
    };

    if(this.props.isComponent) {
      headerGroupProps = {
        ...headerGroupProps,
        row: '0',
        rowSpan: '2',
      }
    }

    headers.unshift(<TableHeaderColumn {...headerGroupProps}>Groupes<br/>d'utilisateur</TableHeaderColumn>);

    return { headers : headers, componentHeaderRefs: componentHeaderRefs };
  }

  /**
  * saveChanges
  * Saves the permissions
  **/
  saveChanges() {
    const permissions = this.refs.tablePermission.state.data;
    const path = REST_API_URL + this.props.path + "/";

    rest({
      method: "PUT",
      path: path,
      entity: JSON.stringify(permissions),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Permissions sauvegardées.'
          }
        });
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * fireSynchronization
  * Launch LDAP/DB synchronization
  **/
  fireSynchronization() {
    rest({method: 'GET', path: REST_API_URL + 'permissions/synchronize/'}).then(response => {
      const res = JSON.parse(response.entity);
      if(res === true) {
        this.setState({
          status: {
            type: 'success',
            message: 'Synchronisation effectuée avec succès.'
          }
        });
        this.componentDidMount();
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur lors de la synchronisation.'
          }
        });
      }
    });
  }

}

export default PermissionGrid;



// WEBPACK FOOTER //
// ./src/views/Search/PermissionList/PermissionGrid.js